/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const FullBodySolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g><path d="M14.5 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" /><path d="m10.79 21.625 1.21-5.44 1.219 5.44a.5.5 0 0 0 .484.375h2.047a.5.5 0 0 0 .496-.561l-1.301-10.5 4.656-.873A.5.5 0 0 0 20 9.483l-.369-1.966a.5.5 0 0 0-.583-.4l-5.758 1.08c-.487.092-.796.137-1.29.137s-.794-.045-1.281-.137L4.96 7.117a.5.5 0 0 0-.584.4L4.01 9.483a.5.5 0 0 0 .399.583l4.656.873-1.301 10.5a.5.5 0 0 0 .496.561h2.047a.5.5 0 0 0 .484-.375Z" /></g></svg>);
const FullBodySolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={FullBodySolidBase} {...rest} ref={ref} />);
export default FullBodySolid;